import * as Sentry from '@sentry/react';
import React from 'react';

import ErrorBoundaryFallback from 'components/atoms/ErrorBoundaryFallback';

export const ErrorBoundary = (props: Sentry.ErrorBoundaryProps) => {
  const { fallback } = props;

  return (
    <Sentry.ErrorBoundary
      {...props}
      fallback={fallback
        ? fallback
        : ({ error, ...rest }) => (
          <ErrorBoundaryFallback
            error={error instanceof Error
              ? { message: error.message }
              : undefined}
            {...rest}
          />
        )}
    />
  );
};
